// Credit pools per tenant and usage logs per app/user

export const tenantCredits = [
  {
    tenantId: 'tn_01',
    periodStart: '2025-08-01T00:00:00Z',
    periodEnd: '2025-08-31T23:59:59Z',
    totalCredits: 200000,
    usedCredits: 10250,
    carryoverFromPrev: 10000,
    resetDay: 1,
  },
  {
    tenantId: 'tn_02',
    periodStart: '2025-08-01T00:00:00Z',
    periodEnd: '2025-08-31T23:59:59Z',
    totalCredits: 50000,
    usedCredits: 5000,
    carryoverFromPrev: 5000,
    resetDay: 1,
  },
  {
    tenantId: 'tn_03',
    periodStart: '2025-08-01T00:00:00Z',
    periodEnd: '2025-08-31T23:59:59Z',
    totalCredits: 3500000,
    usedCredits: 120000,
    carryoverFromPrev: 250000,
    resetDay: 1,
  },
];

export const usageLogs = [
  {
    tenantId: 'tn_01',
    studentId: 'stu_0001',
    appId: 'RightMaths',
    ts: '2025-08-12T08:10:00Z',
    credits: 120, // ~120K tokens if 1 credit = 1K tokens
    purpose: 'lesson_generation',
    meta: { classId: 'MC01A2-P5A', assignmentId: 'rm_hw_0001' },
  },
  {
    tenantId: 'tn_01',
    studentId: 'stu_0002',
    appId: 'RightChinese',
    ts: '2025-08-12T08:20:00Z',
    credits: 80,
    purpose: 'essay_review',
    meta: { classId: 'MC01A2-P5A', assignmentId: 'rc_hw_0002' },
  },
  {
    tenantId: 'tn_02',
    studentId: 'stu_1001',
    appId: 'RightScience',
    ts: '2025-08-12T09:00:00Z',
    credits: 150,
    purpose: 'lab_simulation',
    meta: { classId: 'MC02B3-S3B', assignmentId: 'rs_lab_0001' },
  },
];


